import HomePage from './Pages/Home';
import { AppProvider } from './Utils/Context.js'; 

function App() {
  return (
    <AppProvider>
      <div>
        <HomePage/>
      </div>
    </AppProvider>
  );
}

export default App;
